export interface ICommand { }
export class CreateWorkspaceScaleCommandV1 implements ICommand
{
    $type: string = 'TCh.Domain.Scales.Commands.CreateWorkspaceScaleCommandV1, TCh.Domain.Scales';

    WorkspaceId: number;
    Id: string; 
    Name: string;
    Description: string;
    LevelsSerialized: string;

    constructor(workspaceId: number, discreteScaleId: number, name: string, description: string, levelsSerialized: string)
    {
        this.WorkspaceId = workspaceId;
        this.Id = discreteScaleId.toString();
        this.Name = name;
        this.Description = description;
        this.LevelsSerialized = levelsSerialized;
    }

    static matchType(cmd: any)
    {
        return cmd.$type === 'TCh.Domain.Scales.Commands.CreateWorkspaceScaleCommandV1, TCh.Domain.Scales';
    }
}

export class DeleteWorkspaceScaleCommandV1 implements ICommand
{
    $type: string = 'TCh.Domain.Scales.Commands.DeleteWorkspaceScaleCommandV1, TCh.Domain.Scales';

    WorkspaceId: number;
    Id: string; 

    constructor(workspaceId: number, discreteScaleId: number)
    {
        this.WorkspaceId = workspaceId;
        this.Id = discreteScaleId.toString();
    }

    static matchType(cmd: any)
    {
        return cmd.$type === 'TCh.Domain.Scales.Commands.DeleteWorkspaceScaleCommandV1, TCh.Domain.Scales';
    }
}

export class UpdateWorkspaceScaleCommandV1 implements ICommand
{
    $type: string = 'TCh.Domain.Scales.Commands.UpdateWorkspaceScaleCommandV1, TCh.Domain.Scales';

    WorkspaceId: number;
    Id: string;
    Name: string;
    Description: string;
    LevelsSerialized: string;

    constructor(workspaceId: number, discreteScaleId: number, name: string, description: string, levelsSerialized: string)
    {
        this.WorkspaceId = workspaceId;
        this.Id = discreteScaleId.toString();
        this.Name = name;
        this.Description = description;
        this.LevelsSerialized = levelsSerialized;
    }

    static matchType(cmd: any)
    {
        return cmd.$type === 'TCh.Domain.Scales.Commands.UpdateWorkspaceScaleCommandV1, TCh.Domain.Scales';
    }
}






